import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';

import animator from '../../../helpers/animator';
import UserAvatar from '../../../components/UserAvatar';
import LocationDropDown from '../../../containers/ProjectsContainer/ProjectHierarchy/SubHeader/LocationDropDown';
import dataModel from '../../../models/DataModel';
import MapsHelpers from '../../../helpers/MapsHelpers/MapsHelpers';
import TrashIcon from '../../../components/Iconoclast/TrashIcon';
import DataSource from '../../../dao/DataSource/DataSource';

import './CompanyHeader.scss';

var slideInTime = 100;

export class CompanyHeader extends BaseComponent {

  constructor(props) {
    super(props);
    const { company } = this.props;
    this.animator = new animator();
    this.animate = false;
    this.currentDropDownSize = 290;
    this.closeOtherAndOpenNewDropDown = this.closeOtherAndOpenNewDropDown.bind(this);
    this.cachedDropDownDisplay = '';

    this.state = { 
      selectedUser: null, 
      displayDropDown: '',
      company,
    };

    if (company) {
      if(company.city && company.state && company.address_1){
        MapsHelpers.getLatitudeLongitude(company.address_1 + ' ' +
          company.city + ', ' +
          company.state + ' ' + company.state, (results) => {
          if (results) {
            company.latitude = results.latitude;
            company.longitude = results.longitude;
          }
        });
      }
    }
    this.queryDeleteCompany = this.queryDeleteCompany.bind(this);
  }

  handleCompanyUpdate(company, action) {
    this.setState({ company });
    if (action != 'prefetch') {
      this.fetchCompanyUsers();
      this.setState({ displayDropDown: '' });
    }
    else if (action == 'delete') {
      
    }
  }

  handleSetCompanyDataSource(company) {
    if (company) {
      this.companyDataSource = new DataSource('Company', company, {
        company: {
          admin: {}, contact: {}, additionalFields: ['logo'], vendor_users: {},
        },
      }, this.handleCompanyUpdate);
      this.companyDataSource.get();
    }
  }
  
  componentDidMount() {
    super.componentDidMount();
    this.handleSetCompanyDataSource(this.props.company);
  }

  componentWillUnmount() {
    if (this.companyDataSource) {
      this.companyDataSource.release();
    }
  }

  componentDidUpdate(prevProps) {
    const { company } = prevProps;
    const newCompany = this.props.company;

    if (newCompany.id != company.id) {
      if (this.companyDataSource){
        this.companyDataSource.release();
      }
      this.handleSetCompanyDataSource(this.props.company);
    }
  }

  fetchCompanyUsers() {
    const { company } = this.state;
    if (company) {
      if (company.contact_id || (company.contact && company.contact.id)) {
        const contactId = company.contact_id || company.contact.id;
        dataModel.usersDAO.getUser(contactId).then(user => {
          company.contact = user;
          this.setState({ company });
        });
      }
      if (company.admin_id || (company.admin && company.admin.id)) {
        const adminId = company.admin_id || company.admin.id;
        dataModel.usersDAO.getUser(adminId).then(user => {
          company.admin = user;
          this.setState({ company });
        });
      }
    }
  }

  handleMapRequest() {
    const { displayDropDown } = this.state;
    if (this.props.handleExpansion) {
      if (displayDropDown != '') {
        this.closeOtherAndOpenNewDropDown('mapDisplay', 290, true);
      }
      else {
        this.openNewDropDown('mapDisplay', 290, true);
      }
    }
  }

  handleCloseDropdown(e) {
    if (this.props.handleExpansion) {
      switch (this.state.displayDropDown) {
      case 'mapDisplay':
        this.handleMapRequest();
        break;
      default:
        break;
      }
      this.props.handleExpansion(0);
    }
  }

  openNewDropDown(displayDropDown, size, animate) {
    if (displayDropDown == 'mapDisplay') {
      this.props.handleExpansion(273);
    }
    this.currentDropDownSize = size;
    this.setState({ displayDropDown: displayDropDown });
    this.animate = true;
  }

  closeOtherAndOpenNewDropDown(newDisplayDropDown, newSize, animate) {
    let _this = this;
    if (animate) {
      const animatorGroup = [];

      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(0, animatorGroup, slideInTime);
      }
      const { displayDropDown } = _this.state;
      if (displayDropDown) {
        this.cachedDropDownDisplay = null;
        let ani = _this.animator.createPropertyAnimation(displayDropDown, slideInTime,
          { height: { startVal: this.currentDropDownSize, endVal: 0 } });
        animatorGroup.push(ani);
      }
      if (animatorGroup.length > 0) {
        _this.animator.addCollection(animatorGroup, false);
        setTimeout(function() {
          _this.animator.processAnimationQueue(() => {
            const { handleExpand } = _this.props;
            if (handleExpand) {
              handleExpand(0);
            }
            // Dont reopen the new one
            if (newDisplayDropDown != displayDropDown) {
              _this.openNewDropDown(newDisplayDropDown, newSize, animate);
            }
            else {
              _this.setState({ displayDropDown: '' });
              _this.props.handleExpansion(0);
            }
          });
        }, 10);
      }
    }
  }

  createMapDisplay(animate) {
    const { company } = this.state;
    const locationDropDown = <LocationDropDown company={company} height={animate ? 0 : 290} handleCloseDropDown={this.handleCloseDropdown} />;

    if (!animate) {
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(290);
      }
    }
    else {
      this.animateMe('mapDisplay', 290, true);
    }

    return locationDropDown;
  }

  animateMe(id, finalHeight, expandContainer) {
    this.animating = true;
    const animationGroup = [];
    if (expandContainer) {
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(finalHeight, animationGroup, slideInTime * 2 / 3);
      }
    }
    let ani = this.animator.createPropertyAnimation(id, slideInTime * 2 / 3, { height: { startVal: 0, endVal: finalHeight } });
    animationGroup.push(ani);
    this.animator.addCollection(animationGroup, false);
    let _this = this;
    setTimeout(function() {
      _this.animator.processAnimationQueue(() => {
        _this.animating = false;
        if (expandContainer) {
          const { handleExpand } = _this.props;
          if (handleExpand) {
            handleExpand(finalHeight);
          }
        }
        else {
          this.hoverDownHasDisplayed = true;
        }
      });
    }, 30);
  }

  handleCancelCompanyEdit() {
    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  handleSaveCompany() {
    const { company } = this.props;
    if (this.props.onSave) {
      this.props.onSave();
      this.setState({ company });
    }
  }

  doDeleteCompany() {
    // Get anyone but this one
    this.companyDataSource.delete().then(() => {
      dataModel.companiesDAO.getCurrentCompany(this.state.company.id * -1).then(newCurrentCompany => {
        if (this.props.selectCompany && newCurrentCompany) {
          this.props.selectCompany(newCurrentCompany);
        }
      });
    });
  }

  queryDeleteCompany() {
    const message = this.textMap.companyArchiveQuestion;

    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      height: 250,
      message: message, 
      cancelButtonText: this.textMap.cancel, 
      okButtonText: this.textMap.deleteCompany,
      handleOwnerOk: () => {
        this.doDeleteCompany();
      }, 
    });
  }

  render() {
    const { displayDropDown, company } = this.state;

    if (!company || !this.props.currentUser) {
      return null;
    }

    let dropDown = null;

    let mapClasses = 'button map-button';
    switch (displayDropDown) {
    case 'mapDisplay':
      mapClasses += ' selected';
      if (this.cachedDropDownDisplay) {
        dropDown = this.cachedDropDownDisplay;
      }
      else {
        this.cachedDropDownDisplay = dropDown = this.createMapDisplay(this.animate);
      }
      break;
    default:
      break;
    }

    let map = null;
    if (this.props.handleExpansion) {
      map = (
        <div className={mapClasses} onClick={this.handleMapRequest}>
          <div className="button-label">MAP</div>
        </div>
      );
    }
    
    const { contact } = company;
    let contactDisplay = <div className="company-manager">
        <UserAvatar id={'company-manager-' + (contact && contact.id ? contact.id : '0')} key={'company-manager ' +(contact && contact.id ? contact.id : 0)} user={contact && contact.id ? contact : null} large={true} />
        <div className="company-manager-id">
          <div className="company-manager-name">{contact && contact.id ? (contact.first_name + ' ' + contact.last_name) : 'None Assigned'}</div>
          <div className="company-manager-role">Company Contact</div>
        </div>
      </div>;

    const { admin } = company;
    let adminDisplay = <div className="company-manager">
        <UserAvatar id={'company-manager-' + (admin && admin.id ? admin.id : '0')} key={'company-contact ' + (admin && admin.id ? admin.id : 0)} user={admin && admin.id ? admin : null} large={true} />
        <div className="company-manager-id">
          <div className="company-manager-name">{admin && admin.id ? (admin.first_name + ' ' + admin.last_name) : 'None Assigned'}</div>
          <div className="company-manager-role">Admin</div>
        </div>
      </div>;

    let controlButtons = null;
    if (this.props.saveButton && !this.props.readOnly) {
      controlButtons = <div className="company-control">
        {this.props.currentUser.super_admin && 
          <div className="delete-button" onClick={this.queryDeleteCompany}>
            <TrashIcon />
          </div>
        }
        <div className="cancel-button" onClick={this.handleCancelCompanyEdit} >
          {this.textMap.cancel.toUpperCase()}
        </div>
        <div className={'save-button' + (!this.props.editCompany ? ' disabled' : '')} onClick={this.props.editCompany ? this.handleSaveCompany : null}>
          {this.textMap.save.toUpperCase()}
        </div>
      </div>;
    }
    else {
      controlButtons = <div className="company-actions">
        <div className='action-buttons'>
          {map}
        </div>
      </div>;
    }

    return (
      <div className="company-header">
        <div className='row'>
          <div className="company-info">
            <div className="company-identity">
              <div className="company-address">
                {(company.city ? company.city : '') + (company.state ? ', ' + company.state : '')}
              </div>
            </div>
          </div>
          {contactDisplay}
          {adminDisplay}
          {controlButtons}
        </div>
        {dropDown &&
          (<div className='row'>
            {dropDown}
          </div>)}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    currentCompany: state.new_companies.currentCompany || null,
    currentUser: state.new_users.currentUser,
  };
};

export default withRouter(connect(mapStateToProps)(CompanyHeader));



// WEBPACK FOOTER //
// ./src/containers/CompaniesContainer/CompanyHeader/index.js